import r from "./identity.js";
import t from "./isFunction.js";
import o from "./isObject.js";
import i from "./isArray.js";
import m from "./matcher.js";
import e from "./property.js";
import s from "./_optimizeCb.js";
function p(p, f, j) {
  return null == p ? r : t(p) ? s(p, f, j) : o(p) && !i(p) ? m(p) : e(p);
}
export { p as default };